(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    const lazyAutoplaySelector = 'deferred-media[data-lazy-autoplay-video]';

  const hydrateLazyVideo = (container) => {
    if (container.hasAttribute('data-media-loaded')) return;

    const content = container.querySelector(':scope > template')?.content.firstElementChild?.cloneNode(true);
    if (!content) return;

    container.setAttribute('data-media-loaded', 'true');
    container.appendChild(content);
    container.querySelector('[ref="deferredMediaPlayButton"]')?.classList.add('deferred-media__playing');
  };

  const setLazyVideoPlayback = (container, shouldPlay) => {
    const video = container.querySelector(':scope > video');
    if (!video) return;

    if (shouldPlay && document.visibilityState === 'visible') {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  };

  const visibleVideoObserver = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        setLazyVideoPlayback(entry.target, entry.isIntersecting && entry.intersectionRatio >= 0.6);
      }
    },
    { threshold: [0, 0.6, 1] }
  );

  const approachingVideoObserver = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;

        hydrateLazyVideo(entry.target);
        visibleVideoObserver.observe(entry.target);
        approachingVideoObserver.unobserve(entry.target);
      }
    },
    { rootMargin: '600px 0px' }
  );

  const observeLazyAutoplayVideos = (root = document) => {
    for (const container of root.querySelectorAll(lazyAutoplaySelector)) {
      if (container.dataset.lazyAutoplayObserved === 'true') continue;

      container.dataset.lazyAutoplayObserved = 'true';
      approachingVideoObserver.observe(container);
    }
  };

  const syncLazyAutoplayVideos = () => {
    for (const container of document.querySelectorAll(lazyAutoplaySelector)) {
      const bounds = container.getBoundingClientRect();
      const visibleHeight = Math.min(bounds.bottom, window.innerHeight) - Math.max(bounds.top, 0);
      const visibleRatio = bounds.height > 0 ? visibleHeight / bounds.height : 0;
      setLazyVideoPlayback(container, visibleRatio >= 0.6);
    }
  };

  observeLazyAutoplayVideos();
  document.addEventListener('shopify:section:load', (event) => observeLazyAutoplayVideos(event.target));
  document.addEventListener('visibilitychange', syncLazyAutoplayVideos);
  } catch(e) { console.error(e); }
})();

})();
